export default __webpack_public_path__ + "8cbc0fc5810192ab4974429f9d8350e4.png";